/**
 * Shared international phone helpers for country-code + local number validation.
 * Guests enter the local number only; country dial code is selected separately.
 */
(function (window) {
  var COUNTRY_PHONE_RULES = {
    '+1': { iso: 'US/CA', placeholder: '5551234567', min: 10, max: 10, pattern: /^[2-9]\d{9}$/, hint: '10 digits, no leading 0 or country code' },
    '+44': { iso: 'UK', placeholder: '7911123456', min: 10, max: 10, pattern: /^[1-9]\d{9}$/, hint: '10 digits, no leading 0' },
    '+91': { iso: 'IN', placeholder: '9876543210', min: 10, max: 10, pattern: /^[6-9]\d{9}$/, hint: '10 digits starting with 6–9' },
    '+92': { iso: 'PK', placeholder: '3001234567', min: 10, max: 10, pattern: /^3\d{9}$/, hint: '10 digits starting with 3 (e.g. 3001234567)' },
    '+61': { iso: 'AU', placeholder: '412345678', min: 9, max: 9, pattern: /^[2-478]\d{8}$/, hint: '9 digits, no leading 0' },
    '+81': { iso: 'JP', placeholder: '9012345678', min: 9, max: 10, pattern: /^[1-9]\d{8,9}$/, hint: '9–10 digits, no leading 0' },
    '+49': { iso: 'DE', placeholder: '1512345678', min: 9, max: 11, pattern: /^[1-9]\d{8,10}$/, hint: '9–11 digits, no leading 0' },
    '+33': { iso: 'FR', placeholder: '612345678', min: 9, max: 9, pattern: /^[1-9]\d{8}$/, hint: '9 digits, no leading 0' },
    '+39': { iso: 'IT', placeholder: '3123456789', min: 9, max: 10, pattern: /^[1-9]\d{8,9}$/, hint: '9–10 digits, no leading 0' },
    '+34': { iso: 'ES', placeholder: '612345678', min: 9, max: 9, pattern: /^[6-9]\d{8}$/, hint: '9 digits, no leading 0' },
    '+971': { iso: 'AE', placeholder: '501234567', min: 9, max: 9, pattern: /^5\d{8}$/, hint: '9 digits starting with 5' },
    '+966': { iso: 'SA', placeholder: '512345678', min: 9, max: 9, pattern: /^5\d{8}$/, hint: '9 digits starting with 5' },
    '+880': { iso: 'BD', placeholder: '1712345678', min: 10, max: 10, pattern: /^1\d{9}$/, hint: '10 digits starting with 1' },
    '+94': { iso: 'LK', placeholder: '712345678', min: 9, max: 9, pattern: /^7\d{8}$/, hint: '9 digits starting with 7' },
    '+86': { iso: 'CN', placeholder: '13812345678', min: 11, max: 11, pattern: /^1\d{10}$/, hint: '11 digits starting with 1' },
    '+65': { iso: 'SG', placeholder: '81234567', min: 8, max: 8, pattern: /^[3689]\d{7}$/, hint: '8 digits' },
    '+60': { iso: 'MY', placeholder: '123456789', min: 9, max: 10, pattern: /^1\d{8,9}$/, hint: '9–10 digits starting with 1' },
    '+27': { iso: 'ZA', placeholder: '821234567', min: 9, max: 9, pattern: /^[6-8]\d{8}$/, hint: '9 digits, no leading 0' },
    '+7': { iso: 'RU/KZ', placeholder: '9123456789', min: 10, max: 10, pattern: /^[3-9]\d{9}$/, hint: '10 digits, no leading 0' },
    '+55': { iso: 'BR', placeholder: '11987654321', min: 10, max: 11, pattern: /^[1-9]\d{9,10}$/, hint: '10–11 digits, no leading 0' },
    '+90': { iso: 'TR', placeholder: '5321234567', min: 10, max: 10, pattern: /^5\d{9}$/, hint: '10 digits starting with 5' },
    '+20': { iso: 'EG', placeholder: '1001234567', min: 10, max: 10, pattern: /^1\d{9}$/, hint: '10 digits starting with 1' },
    '+234': { iso: 'NG', placeholder: '8012345678', min: 10, max: 10, pattern: /^[789]\d{9}$/, hint: '10 digits starting with 7–9' },
    '+254': { iso: 'KE', placeholder: '712345678', min: 9, max: 9, pattern: /^[17]\d{8}$/, hint: '9 digits, no leading 0' },
    '+353': { iso: 'IE', placeholder: '851234567', min: 9, max: 9, pattern: /^[1-9]\d{8}$/, hint: '9 digits, no leading 0' },
    '+64': { iso: 'NZ', placeholder: '211234567', min: 8, max: 10, pattern: /^[2-9]\d{7,9}$/, hint: '8–10 digits, no leading 0' },
    '+852': { iso: 'HK', placeholder: '91234567', min: 8, max: 8, pattern: /^[4-9]\d{7}$/, hint: '8 digits' },
    '+974': { iso: 'QA', placeholder: '33123456', min: 8, max: 8, pattern: /^[3-7]\d{7}$/, hint: '8 digits' },
    '+973': { iso: 'BH', placeholder: '36123456', min: 8, max: 8, pattern: /^[3-6]\d{7}$/, hint: '8 digits' },
    '+965': { iso: 'KW', placeholder: '50123456', min: 8, max: 8, pattern: /^[569]\d{7}$/, hint: '8 digits' },
    '+968': { iso: 'OM', placeholder: '91234567', min: 8, max: 8, pattern: /^[79]\d{7}$/, hint: '8 digits' },
    '+962': { iso: 'JO', placeholder: '791234567', min: 9, max: 9, pattern: /^7\d{8}$/, hint: '9 digits starting with 7' },
    '+961': { iso: 'LB', placeholder: '71123456', min: 7, max: 8, pattern: /^[3-9]\d{6,7}$/, hint: '7–8 digits, no leading 0' },
    '+98': { iso: 'IR', placeholder: '9123456789', min: 10, max: 10, pattern: /^9\d{9}$/, hint: '10 digits starting with 9' },
    '+93': { iso: 'AF', placeholder: '701234567', min: 9, max: 9, pattern: /^7\d{8}$/, hint: '9 digits starting with 7' },
    '+977': { iso: 'NP', placeholder: '9841234567', min: 10, max: 10, pattern: /^9\d{9}$/, hint: '10 digits starting with 9' },
    '+31': { iso: 'NL', placeholder: '612345678', min: 9, max: 9, pattern: /^[1-9]\d{8}$/, hint: '9 digits, no leading 0' },
    '+46': { iso: 'SE', placeholder: '701234567', min: 9, max: 9, pattern: /^[1-9]\d{8}$/, hint: '9 digits, no leading 0' },
    '+41': { iso: 'CH', placeholder: '791234567', min: 9, max: 9, pattern: /^[1-9]\d{8}$/, hint: '9 digits, no leading 0' },
    '+32': { iso: 'BE', placeholder: '470123456', min: 9, max: 9, pattern: /^[1-9]\d{8}$/, hint: '9 digits, no leading 0' },
    '+351': { iso: 'PT', placeholder: '912345678', min: 9, max: 9, pattern: /^[1-9]\d{8}$/, hint: '9 digits, no leading 0' },
    '+48': { iso: 'PL', placeholder: '512345678', min: 9, max: 9, pattern: /^[1-9]\d{8}$/, hint: '9 digits, no leading 0' },
    '+82': { iso: 'KR', placeholder: '1012345678', min: 9, max: 10, pattern: /^1\d{8,9}$/, hint: '9–10 digits starting with 1' },
    '+66': { iso: 'TH', placeholder: '812345678', min: 9, max: 9, pattern: /^[689]\d{8}$/, hint: '9 digits, no leading 0' },
    '+63': { iso: 'PH', placeholder: '9123456789', min: 10, max: 10, pattern: /^9\d{9}$/, hint: '10 digits starting with 9' },
    '+62': { iso: 'ID', placeholder: '8123456789', min: 9, max: 12, pattern: /^8\d{8,11}$/, hint: '9–12 digits starting with 8' },
    '+84': { iso: 'VN', placeholder: '912345678', min: 9, max: 10, pattern: /^[3-9]\d{8,9}$/, hint: '9–10 digits, no leading 0' },
    '+52': { iso: 'MX', placeholder: '5512345678', min: 10, max: 10, pattern: /^[1-9]\d{9}$/, hint: '10 digits, no leading 0' },
    '+54': { iso: 'AR', placeholder: '91123456789', min: 10, max: 11, pattern: /^[1-9]\d{9,10}$/, hint: '10–11 digits, no leading 0' },
    '+57': { iso: 'CO', placeholder: '3001234567', min: 10, max: 10, pattern: /^3\d{9}$/, hint: '10 digits starting with 3' },
    '+51': { iso: 'PE', placeholder: '912345678', min: 9, max: 9, pattern: /^9\d{8}$/, hint: '9 digits starting with 9' }
  };

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function normalizeDialCode(code) {
    var c = String(code || '').trim();
    if (!c) return '';
    if (c.charAt(0) !== '+') c = '+' + c;
    return c;
  }

  function getRule(countryCode) {
    var code = normalizeDialCode(countryCode);
    return COUNTRY_PHONE_RULES[code] || {
      iso: 'INTL',
      placeholder: 'Local number without 0',
      min: 6,
      max: 12,
      pattern: /^[1-9]\d{5,11}$/,
      hint: 'Enter local number only (no leading 0 or country code)'
    };
  }

  function validatePhoneNumber(countryCode, localNumber) {
    var code = normalizeDialCode(countryCode);
    var local = digitsOnly(localNumber);
    var rule = getRule(code);
    var codeDigits = digitsOnly(code);

    if (!code) {
      return { valid: false, message: 'Please select a country code.', local: local, e164: '' };
    }
    if (!local) {
      return { valid: false, message: 'Please enter your phone number.', local: local, e164: '' };
    }
    if (local.charAt(0) === '0') {
      return {
        valid: false,
        message: 'Do not include a leading 0 when ' + code + ' is selected. Example: ' + rule.placeholder,
        local: local,
        e164: ''
      };
    }
    if (codeDigits && local.indexOf(codeDigits) === 0) {
      return {
        valid: false,
        message: 'Do not repeat the country code in the phone number. Enter the local number only.',
        local: local,
        e164: ''
      };
    }
    if (local.length < rule.min || local.length > rule.max) {
      return {
        valid: false,
        message: 'Invalid phone for ' + code + '. Expected ' + (rule.min === rule.max ? rule.min : rule.min + '–' + rule.max) + ' digits. ' + rule.hint + '.',
        local: local,
        e164: ''
      };
    }
    if (rule.pattern && !rule.pattern.test(local)) {
      return {
        valid: false,
        message: 'Invalid phone number format for ' + code + '. ' + rule.hint + '.',
        local: local,
        e164: ''
      };
    }
    return { valid: true, message: '', local: local, e164: code + local };
  }

  function bindPhoneField(options) {
    var codeEl = typeof options.countryCode === 'string' ? document.getElementById(options.countryCode) : options.countryCode;
    var phoneEl = typeof options.phone === 'string' ? document.getElementById(options.phone) : options.phone;
    var errorEl = typeof options.error === 'string' ? document.getElementById(options.error) : options.error;
    if (!codeEl || !phoneEl) return null;

    function applyPlaceholder() {
      var rule = getRule(codeEl.value);
      phoneEl.setAttribute('placeholder', rule.placeholder);
      phoneEl.setAttribute('inputmode', 'numeric');
      phoneEl.setAttribute('autocomplete', 'tel-national');
      phoneEl.setAttribute('maxlength', String(rule.max + 2));
      if (options.hintEl) {
        var hint = typeof options.hintEl === 'string' ? document.getElementById(options.hintEl) : options.hintEl;
        if (hint) hint.textContent = 'Format: ' + codeEl.value + ' ' + rule.placeholder + ' (' + rule.hint + ')';
      }
    }

    function showError(message) {
      phoneEl.classList.add('input-error');
      phoneEl.classList.add('error');
      phoneEl.setAttribute('aria-invalid', 'true');
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.classList.add('visible');
        errorEl.style.display = 'block';
      }
    }

    function hideError() {
      phoneEl.classList.remove('input-error');
      phoneEl.classList.remove('error');
      phoneEl.removeAttribute('aria-invalid');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('visible');
        errorEl.style.display = 'none';
      }
    }

    function sanitize() {
      var cleaned = digitsOnly(phoneEl.value);
      var rule = getRule(codeEl.value);
      if (cleaned.length > rule.max) cleaned = cleaned.slice(0, rule.max);
      if (phoneEl.value !== cleaned) phoneEl.value = cleaned;
      return cleaned;
    }

    function validate(showMsg) {
      sanitize();
      var result = validatePhoneNumber(codeEl.value, phoneEl.value);
      if (result.valid) hideError();
      else if (showMsg !== false) showError(result.message);
      return result;
    }

    codeEl.addEventListener('change', function () {
      applyPlaceholder();
      if (phoneEl.value) validate(true);
    });
    phoneEl.addEventListener('input', function () {
      sanitize();
      if (phoneEl.value) validate(true);
      else hideError();
    });
    phoneEl.addEventListener('blur', function () {
      validate(true);
    });

    applyPlaceholder();
    return {
      validate: validate,
      getE164: function () {
        var result = validate(false);
        return result.valid ? result.e164 : '';
      },
      hideError: hideError,
      showError: showError
    };
  }

  window.CdpPhone = {
    rules: COUNTRY_PHONE_RULES,
    getRule: getRule,
    validate: validatePhoneNumber,
    bind: bindPhoneField,
    digitsOnly: digitsOnly
  };
})(window);
